import type { MouseEvent, ReactNode } from "react";

/** Stops TableKit row click/open when interacting with inline actions. */
export function TableRowActions({ children }: { children: ReactNode }) {
  return (
    <div
      className="table-row-actions"
      onClick={(event: MouseEvent) => {
        event.stopPropagation();
      }}
      onMouseDown={(event: MouseEvent) => {
        event.stopPropagation();
      }}
    >
      {children}
    </div>
  );
}
